/**
* Campus Map JS
* -----------------------------------------------------------------------------
*
* All the JS for the Campus Map component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
// import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {

    className: 'campus-map',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.campus-map__item' ).each( function( key, item ) {
        const height = $( this ).outerHeight();
        const interaction = $( '.campus-map__map' ).find( '.campus-map__interaction[data-title="' + $( item ).attr( 'data-interaction' ) + '"]' );
        const interactionText = $( '.campus-map__map' ).find( '.campus-map__interaction-text[data-title="' + $( item ).attr( 'data-interaction' ) + '"]' );

        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 50%',
            end: 'bottom 50%',
            scrub: 0,
            onEnter: ( {progress, direction, isActive} ) => {
              $( interaction ).addClass( 'is-active' );
              $( interactionText ).addClass( 'is-active' );
            },
            onLeave: ( {progress, direction, isActive} ) => {
              $( interaction ).removeClass( 'is-active' );
              $( interactionText ).removeClass( 'is-active' );
            },
            onEnterBack: ( {progress, direction, isActive} ) => {
              $( interaction ).addClass( 'is-active' );
              $( interactionText ).addClass( 'is-active' );
            },
            onLeaveBack: ( {progress, direction, isActive} ) => {
              $( interaction ).removeClass( 'is-active' );
              $( interactionText ).removeClass( 'is-active' );
            },
            // markers: true,
          },
        } );
      } );

      this.initMagnifier();
      this.initTouchZoom();
    },

    initMagnifier: function() {
      if ( ! window.matchMedia( '(hover: hover) and (pointer: fine)' ).matches ) {
        return;
      }

      const map = document.querySelector( '.campus-map__map' );
      const lens = document.querySelector( '.campus-map__lens' );
      const lensSvg = lens && lens.querySelector( '.campus-map__lens-svg' );

      if ( ! map || ! lens || ! lensSvg ) {
        return;
      }

      const ZOOM = 3;
      const VB_W = 815; // map viewBox width
      const VB_H = 719; // map viewBox height
      const WIN_W = VB_W / ZOOM;
      const WIN_H = VB_H / ZOOM;

      const reduceMotion = window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;
      const duration = reduceMotion ? 0 : 0.4;

      gsap.set( lens, {xPercent: -50, yPercent: -50} );
      const xTo = gsap.quickTo( lens, 'x', {duration: duration, ease: 'power3'} );
      const yTo = gsap.quickTo( lens, 'y', {duration: duration, ease: 'power3'} );

      const onMove = function( e ) {
        const rect = map.getBoundingClientRect();
        if ( ! rect.width || ! rect.height ) {
          return;
        }

        // Cursor position translated into the map's SVG coordinate space.
        let cx = ( e.clientX - rect.left ) / rect.width * VB_W;
        let cy = ( e.clientY - rect.top ) / rect.height * VB_H;

        // Clamp so the zoom window never runs past the edges of the map.
        cx = Math.max( WIN_W / 2, Math.min( VB_W - WIN_W / 2, cx ) );
        cy = Math.max( WIN_H / 2, Math.min( VB_H - WIN_H / 2, cy ) );

        lensSvg.setAttribute(
            'viewBox',
            ( cx - WIN_W / 2 ) + ' ' + ( cy - WIN_H / 2 ) + ' ' + WIN_W + ' ' + WIN_H,
        );

        xTo( e.clientX );
        yTo( e.clientY );
      };

      map.addEventListener( 'pointerenter', function() {
        lens.classList.add( 'is-active' );
      } );
      map.addEventListener( 'pointermove', onMove );
      map.addEventListener( 'pointerleave', function() {
        lens.classList.remove( 'is-active' );
      } );
    },

    initTouchZoom: function() {
      const trigger = document.querySelector( '.campus-map__zoom-trigger' );

      if ( ! trigger || typeof $.magnificPopup === 'undefined' ) {
        return;
      }

      $( trigger ).on( 'click', function() {
        $.magnificPopup.open( {
          items: {
            src: $( this ).data( 'mfp-src' ),
            type: 'inline',
          },
          mainClass: 'campus-map__mfp',
          removalDelay: 300,
          closeOnContentClick: false,
        } );
      } );
    },

    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'campus-map', COMPONENT );
} )( app );
